import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormattedNumberPipe } from '../../pipes/formatted-number.pipe';
import { FormatCurrencyPipe } from '../../pipes/format-currency.pipe';
import { Currency } from '../currency-selector/currency-country-codes';
import { TrimWebsiteUrlPipe } from '../../pipes/trim-website-url.pipe';
import { FormattedPercentPipe } from '../../pipes/formatted-percent.pipe';
import { FileSizePipe } from '../../../pages/authenticated/documents/pipes/file-size.pipe';
import { SbTooltipInfoComponent } from '../sb-tooltip-info/sb-tooltip-info.component';

export type SbKeyValueList = Array<
    | SbTextKeyValue
    | SbNumberKeyValue
    | SbCurrencyKeyValue
    | SbDateKeyValue
    | SbPercentKeyValue
    | SbLinkKeyValue
    | SbFileSizeKeyValue
>;

interface SbKeyValueItem {
    key: string;
}

interface SbTextKeyValue extends SbKeyValueItem {
    type: 'text';
    value: string;
}

interface SbCurrencyKeyValue extends SbKeyValueItem {
    type: 'currency';
    value: number;
    addChangePrefix?: boolean;
    useColor?: boolean;
    digitsInfo?: string;
    description?: string;
}
interface SbNumberKeyValue extends SbKeyValueItem {
    type: 'number';
    value: number;
    addChangePrefix?: boolean;
    useColor?: boolean;
    digitsInfo?: string;
    description?: string;
}
interface SbDateKeyValue extends SbKeyValueItem {
    type: 'date';
    format?: string;
    value: number | Date;
}
interface SbPercentKeyValue extends SbKeyValueItem {
    type: 'percent';
    value: number;
    addChangePrefix?: boolean;
    useColor?: boolean;
    digitsInfo?: string;
}
interface SbLinkKeyValue extends SbKeyValueItem {
    type: 'link';
    value: string;
}
interface SbFileSizeKeyValue extends SbKeyValueItem {
    type: 'fileSize';
    value: number;
}
@Component({
    selector: 'sb-key-value-list',
    standalone: true,
    imports: [
        CommonModule,
        FormattedNumberPipe,
        FormatCurrencyPipe,
        TrimWebsiteUrlPipe,
        FormattedPercentPipe,
        FileSizePipe,
        SbTooltipInfoComponent
    ],
    templateUrl: './sb-key-value-list.component.html',
    styleUrls: ['./sb-key-value-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbKeyValueListComponent {
    get useShortNumberFormat(): boolean {
        return this._useShortNumberFormat;
    }

    @Input() set useShortNumberFormat(value: boolean) {
        this._useShortNumberFormat = value;
    }
    get useTableStyle(): boolean {
        return this._useTableStyle;
    }

    @Input() set useTableStyle(value: boolean) {
        this._useTableStyle = value === true || (value as unknown) === 'true';
    }
    get currency(): Currency {
        return this._currency;
    }

    @Input() set currency(value: Currency) {
        this._currency = value;
    }
    get keyValues() {
        return this._keyValues;
    }

    @Input() set keyValues(value) {
        this._keyValues = value;
    }
    private _useShortNumberFormat = false;
    private _keyValues: SbKeyValueList;
    private _currency: Currency;
    private _useTableStyle: boolean = true;

    toggleShortNumberFormat() {
        this._useShortNumberFormat = !this._useShortNumberFormat;
        this._cdr.markForCheck();
    }
    constructor(private _cdr: ChangeDetectorRef) {}
}
